module.exports = __webpack_public_path__ + "static/media/Adults.cc80877e.png";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/experiences/resources/onboardig/Adults.png
// module id = 3829
// module chunks = 0